import googleTagAnalytics from 'Root/drivers/googleTagAnalytics';
import { urlRegexp } from 'Root/helpers/regexps';
import AppModel from 'Root/models/AppModel';
import paymentSystemModel from 'Models/PaymentSystemModel';

const { API_URI } = AppModel;

export default {
  data() {
    return {
      paymentError: '',
    };
  },

  methods: {
    async proceed(orderId, paymentSystemId = null) {
      googleTagAnalytics.fireSavedOrdersEvent('proceed_to_payment');

      this.paymentError = '';
      this.disableInterface();

      let paymentId = paymentSystemId || +this.data?.order?.payment_system;
      if (!this.$store.state.isPlatformApp
        && [paymentSystemModel.METHODS.APPLE_PAY.id, paymentSystemModel.METHODS.GOOGLE_PAY.id].includes(paymentId)) {
        paymentId = paymentSystemModel.METHODS.CARD.id;
      }

      let data;
      await this.$axios.post(`${API_URI}/order/${typeof orderId === 'string' ? orderId : this.data.order?.id}/pay`, {
        payment_system_id: paymentId,
      })
        .then((d) => {
          data = d.data;
          this.$vuedals.dismiss();
        })
        .catch((error) => {
          this.paymentError = error.response?.data?.errors?.message || 'An error occurred during payment processing';
          this.enableInterface();
        });

      if (!data?.url) {
        return;
      }

      if (data.url.match(urlRegexp)) {
        const pathToRedirect = new URL(data.url);

        document.location.href = pathToRedirect.href;
      } else if (window.stripe) {
        const { error } = await window.stripe.redirectToCheckout({
          sessionId: data.url,
        });

        if (error) {
          this.enableInterface();
          throw new Error(`Payment Error: ${error.message}`);
        }
      } else {
        this.enableInterface();
        throw new Error('window.stripe is undefined');
      }
    },

    disableInterface() {
      this.$store.dispatch('showScreenHolder', 'payment');
    },

    enableInterface() {
      this.$store.dispatch('hideScreenHolder');
    },
  },
};
